// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function clearHashFromUrl(historyService: any): void {
    const base = window.location.pathname + (window.location.search || '')
    historyService.history.replace(base)
}

export const readHashParam = (key: string): string | null => {
    const raw = window.location.hash.replace(/^#/, '')
    if (!raw) {
        return null
    }
    const sp = new URLSearchParams(raw)

    return sp.get(`${key}-app`) ?? sp.get(key)
}

export const setHashParam = (key: string, value: string) => {
    const sp = new URLSearchParams(window.location.hash.replace(/^#/, ''))
    const paramKey = `${key}-app`
    if (value) {
        sp.set(paramKey, value)
    } else {
        sp.delete(paramKey)
    }
    const next = sp.toString()
    const base = window.location.pathname + (window.location.search || '')
    const nextUrl = next ? `${base}#${next}` : base
    window.history.replaceState({}, '', nextUrl)
}
